import React from "react";
import { ITextFieldStyles, IDropdownStyles, IButtonStyles } from "@fluentui/react";

export const styles: Record<string, React.CSSProperties> = {
    page: {
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
    },
    top: {
        alignSelf: 'center',
    },
    middle: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    bottom: {
        alignSelf: 'center',
        marginBottom: 20,
    },
};

export const textFieldStyles: Partial<ITextFieldStyles> = {
    fieldGroup: {
        height: 40
    },
    field: {
        fontSize: 14,
        padding: 10
    },
    subComponentStyles: {
        label: {
            root: {
                fontWeight: 'thin'
            }
        }
    }
};

export const dropdownStyles: Partial<IDropdownStyles> = {
    label: {
        fontWeight: 'thin'
    },
    dropdown: {
        borderColor: 'white',
    },
    title: {
        height: 40,
        paddingTop: 5,
    },
    caretDown: {
        color: 'blue',
        paddingTop: 5,
        paddingRight: 5
    },
    dropdownItem: {
        backgroundColor: 'white',
    },
    dropdownItemSelected: {
        backgroundColor: '#fde354',
        color: 'black',
    },
};

export const primaryButtonStyles: Partial<IButtonStyles> = {
    root: {
        backgroundColor: '#fde354',
        borderRadius: 6,
        height: 40,
        width: "100%"
    },
    rootHovered: {
        backgroundColor: '#fde354'
    },
    rootPressed: {
        backgroundColor: '#fde354',
    },
    label: {
        //fontWeight: 600,
        //fontSize: 14,
    },
};

export const defaultButtonStyles: Partial<IButtonStyles> = {
    root: {
        backgroundColor: 'white',
        borderRadius: 6,
        height: 40,
        width: "100%"
    }
};